import { AxiosInstance } from "../../axios/axiosInstance"
import { apiRoutes } from "../../utils/ApiRoutes";

export const businessSearch = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.businessSearch, payload)
    return response
}

export const searchAddressApi = async (payload: { searchText: string; sessionToken?: string } | string) => {
    const data = typeof payload === "string" ? { searchText: payload } : payload;
    const response = await AxiosInstance.post(apiRoutes?.searchAddress, data)
    return response
}

export const createPublicReport = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.createPublicReport, payload)
    return response
}
export const getPlaceDetailsApi = async (payload: { placeId: string; sessionToken?: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.placeDetails, payload)
    return response
}
